// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"7eabb128","453":"15caa7a9"}[chunkId] + ".chunk.js";
};